/* eslint-disable angular/constant-name */

angular.
module("dx.webapp.invigilator").
constant("DX_INVIGILATOR_SETTINGS",
	Object.freeze({
		NONE: 0,
		START_EXAM: 1,
		END_EXAM: 2,
		LOCK_EXAM: 4,
		DOWNLOAD_EXAM: 8,
	})
);
